import { styled } from 'styled-components';
export const Separator = styled.div `
  height: 1px;
  width: 100%;
  background-color: ${(props) => props.theme.colors.horizon};
  margin-top: 10px;
  margin-bottom: 10px;
`;
//# sourceMappingURL=Separator.js.map